<template>
  <div v-show="show" class="the-intro-note-viewer">
    <AppButtonIcon
      :icon="buttonIcon"
      :size="buttonSize"
      :button-style="buttonStyle"
      class="the-intro-note-viewer__close-button"
      @click.native="hideIntroNoteViewer"
    />
    <h1>{{ introNoteTitle }}</h1>
    <div class="the-intro-note-viewer__text-wrapper">
      <AppScrollbarContainer
        class="the-intro-note-viewer__text-wrapper__content"
      >
        <div class="text" v-html="introNoteText"></div>
      </AppScrollbarContainer>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AppScrollbarContainer from '@/components/UIKit/Standard/Atoms/AppScrollbarContainer'
import AppButtonIcon from '@/components/UIKit/Standard/Atoms/AppButton/AppButtonIcon'
import iconNames from '@/constants/ui-kit/standard/icon-names'
import styles from '@/constants/ui-kit/standard/styles'
import sizes from '@/constants/ui-kit/standard/sizes'

export default {
  name: 'TheIntroNoteViewer',
  components: {
    AppScrollbarContainer,
    AppButtonIcon,
  },
  data() {
    return {
      buttonIcon: iconNames.UIClose,
      buttonStyle: styles.LINK,
      buttonSize: sizes.SM,
      show: true,
    }
  },
  computed: {
    ...mapGetters({
      introNote: 'Project/introNote',
    }),
    introNoteText() {
      return this.introNote.html
    },
    introNoteTitle() {
      return this.introNote.title
    },
  },
  methods: {
    hideIntroNoteViewer() {
      this.show = false
    },
  },
}
</script>
<style lang="scss" scoped>
.the-intro-note-viewer {
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  background-color: #000000cc;
  color: #fff;
  height: 200px;
  width: 100%;
  max-width: 600px;
  align-items: start;
  justify-content: start;

  &__close-button {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    z-index: 1;
  }

  h1 {
    font-size: 1rem;
    font-weight: bold;
  }
  &__text-wrapper {
    flex: 1;
    display: flex;
    width: 100%;
    position: relative;

    &__content {
      width: 100%;
      position: absolute;
      inset: 0;
      @include small-screens {
        overflow-y: auto;
      }
    }
  }
  @include small-screens {
    height: 150px;
    font-size: 0.8rem;
    max-width: 90vw;
  }
  @include small-screens-vertical {
    max-width: 90vw;
  }
}
</style>
